import { apiFetcher } from "./apiFetcher";

/**
 * Detects whether a Wix Stores site uses Catalog V1 or V3.
 *
 * Wix is migrating sites to Catalog V3 (default for new sites). V1 and V3 are not
 * backwards-compatible, so every catalog read must first resolve the version and route
 * accordingly. `GET stores/v3/provision/version` works for both and returns
 * `V1_CATALOG` | `V3_CATALOG` | `STORES_NOT_INSTALLED`. The version is permanent per
 * site, so we memoize it per storeId. On error we default to `'V1'` (historical behaviour).
 */
const versionCache = {};

function getCatalogVersion(storeId, accessToken) {
  if (versionCache[storeId]) {
    return Promise.resolve(versionCache[storeId]);
  }

  return apiFetcher(storeId, accessToken, 'stores/v3/provision/version', { method: 'GET' })
    .then((response) => {
      const version = response?.catalogVersion === 'V3_CATALOG' ? 'V3' : 'V1';
      versionCache[storeId] = version;
      return version;
    })
    .catch(() => 'V1');
}

export const versioningService = {
  getCatalogVersion,
};
